import { type RouteRecordRaw } from 'vue-router'

import { eModules } from '@/constants'
import Layout from '@/layout/index.vue'

export const logs: RouteRecordRaw[] = [
  {
    path: '/logs',
    // component: Layout,
    components: {
      default: () => import('@/modules/module-logs/views/logs/index.vue'),
    },
    name: 'Logs',
    meta: {
      affix: true,
      allowedModules: [eModules.LOGS],
      layout: Layout,
      title: 'Logs',
      icon: '',
    },
  },
]
